(function () {
  var STORAGE_KEY = 'fm_recently_viewed';
  var MAX_ITEMS = 10;
  var MAX_DISPLAY = 8;

  function getViewed() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveViewed(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function trackCurrentProduct(handle) {
    if (!handle) return;
    var viewed = getViewed().filter(function (h) { return h !== handle; });
    viewed.unshift(handle);
    if (viewed.length > MAX_ITEMS) viewed = viewed.slice(0, MAX_ITEMS);
    saveViewed(viewed);
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(cents, format);
      } catch (e) {}
    }
    return value;
  }

  function buildCard(product) {
    var variant = product.variants && product.variants[0];
    var price = variant ? variant.price : product.price;
    var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var soldOut = variant ? !variant.available : !product.available;
    var onSale = compareAt && Number(compareAt) > Number(price);

    var badge = '';
    if (soldOut) {
      badge = '<div class="related-product-row__badge related-product-row__badge--sold-out">' +
        (window.themeStrings && window.themeStrings.soldOut ? window.themeStrings.soldOut : 'Sold out') +
        '</div>';
    } else if (onSale) {
      badge = '<div class="related-product-row__badge related-product-row__badge--sale">' +
        (window.themeStrings && window.themeStrings.onSale ? window.themeStrings.onSale : 'Sale') +
        '</div>';
    }

    var priceHtml = '<span class="related-product-row__price-amount">' + money(price) + '</span>';
    var compareHtml = onSale
      ? '<div class="related-product-row__compare-price"><span class="related-product-row__compare-amount">' + money(compareAt) + '</span></div>'
      : '';

    return (
      '<div class="related-product-row__item">' +
        '<a href="/products/' + product.handle + '" class="related-product-row__link">' +
          '<div class="related-product-row__image-wrapper">' +
            badge +
            '<img loading="lazy" src="' + image + '" class="related-product-row__image" alt="' + (product.title || '').replace(/"/g, '&quot;') + '">' +
          '</div>' +
        '</a>' +
        '<div class="related-product-row__info">' +
          '<h3 class="related-product-row__title">' + product.title + '</h3>' +
          '<div class="related-product-row__price">' + priceHtml + compareHtml + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .catch(function () { return null; });
  }

  function wireTabs(section) {
    var tabButtons = section.querySelectorAll('.related-product-row__tab');
    var tabContents = section.querySelectorAll('[data-tab-content]');

    tabButtons.forEach(function (btn) {
      if (btn.dataset.fmWired) return;
      btn.dataset.fmWired = '1';
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-target');
        tabButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        tabContents.forEach(function (c) {
          c.style.display = c.getAttribute('data-tab-content') === target ? '' : 'none';
        });
      });
    });
  }

  function renderRecentlyViewed(section) {
    var currentHandle = section.dataset.currentProduct;
    trackCurrentProduct(currentHandle);

    var viewed = getViewed().filter(function (h) { return h !== currentHandle; }).slice(0, MAX_DISPLAY);
    if (!viewed.length) return;

    var tabsWrap = section.querySelector('.related-product-row__tabs');
    var recentGrid = section.querySelector('[data-tab-content="recently-viewed"]');
    var recentTabButton = section.querySelector('[data-tab-target="recently-viewed"]');
    if (!tabsWrap || !recentGrid || !recentTabButton) return;

    Promise.all(viewed.map(fetchProduct)).then(function (products) {
      var html = products.filter(Boolean).map(buildCard).join('');
      if (!html) return;

      recentGrid.innerHTML = html;
      tabsWrap.style.display = '';
      recentTabButton.style.display = '';

      wireTabs(section);
    });
  }

  function handleSectionReady(section) {
    if (!section || section.dataset.fmRendered) return;
    section.dataset.fmRendered = '1';
    renderRecentlyViewed(section);
  }

  document.addEventListener('fm:related-products-loaded', function (e) {
    handleSectionReady(e.detail && e.detail.section);
  });

  function fallbackInit() {
    document.querySelectorAll('.related-product-row[data-current-product]').forEach(function (section) {
      handleSectionReady(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(fallbackInit, 2500);
    });
  } else {
    setTimeout(fallbackInit, 2500);
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(fallbackInit, 800);
  });
})();
